import React from "react";

export const StyledText = (props) => {
    const { children } = props;
    // const { text } = contentState.getEntity(entityKey).getData();
    return React.Children.map(children, (child) => {
        const styles = processStyles(child.props.styleSet);
        return (
            <span data-offset-key={props.offsetkey} style={styles}>{children}</span>
        )
    });
};


function processStyles(styleSet){
    let styles = {};
    const it = styleSet.entries();
    let result = it.next();
    while (!result.done) {
        const value = result.value[0];
        if(value.indexOf("bgcolor-") === 0){
            styles.backgroundColor = value.substring(8);
        }else if(value.indexOf("color-") === 0){
            styles.color = value.substring(6);
        }
        result = it.next();
    }

    return styles;
}
